// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const SearchIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4146 5.13462C11.9259 5.13462 9.90842 7.15211 9.90842 9.64081C9.90842 12.1295 11.9259 14.147 14.4146 14.147C16.9033 14.147 18.9208 12.1295 18.9208 9.64081C18.9208 7.15211 16.9033 5.13462 14.4146 5.13462ZM9.01709 9.64081C9.01709 6.65984 11.4336 4.24329 14.4146 4.24329C17.3956 4.24329 19.8121 6.65984 19.8121 9.64081C19.8121 12.6218 17.3956 15.0383 14.4146 15.0383C11.4336 15.0383 9.01709 12.6218 9.01709 9.64081Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.406 9.21582C17.6522 9.21582 17.8517 9.41535 17.8517 9.66149C17.8517 11.5582 16.3317 13.0783 14.4349 13.0783C14.1888 13.0783 13.9893 12.8787 13.9893 12.6326C13.9893 12.3865 14.1888 12.1869 14.4349 12.1869C15.8394 12.1869 16.9604 11.066 16.9604 9.66149C16.9604 9.41535 17.1599 9.21582 17.406 9.21582Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0819 13.0592C11.2559 13.2333 11.2559 13.5155 11.0819 13.6895L5.79986 18.9715C5.62582 19.1455 5.34364 19.1455 5.16959 18.9715C4.99555 18.7974 4.99555 18.5153 5.1696 18.3412L10.4516 13.0592C10.6256 12.8852 10.9078 12.8852 11.0819 13.0592Z"
      fill="currentColor"
    />
  </Icon>
);
